import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TRANSACTION_SPINNER_CONFIG } from '@fmr-pr175919/fc-core-ui-lib';
import { AchEnrollmentAppConstants } from '@src/app/features/ach-enrollment/constants/app-constants';
import { AchEnrollment } from '@src/app/features/ach-enrollment/models/ach-enrollment.model';
import { environment } from '@src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AchEnrollmentService {
    private readonly baseUrl: string;
    achEnrollment!: AchEnrollment;

    constructor(private readonly httpClient: HttpClient) {
        this.baseUrl = `${environment.baseUrl}`;
    }

    createAchEnrollment(achEnrollment: AchEnrollment): Observable<unknown> {
        const enrollUrl = `${this.baseUrl}/npoEnrollment`;

        const httpOptions = {
            context: new HttpContext().set(TRANSACTION_SPINNER_CONFIG, {}),
        };

        return this.httpClient.post(enrollUrl, achEnrollment, httpOptions);
    }

    buildAchEnrollmentObject(formdata: FormGroup): AchEnrollment {
        if (formdata) {
            this.achEnrollment = {
                organizationName: formdata.get('organizationName')?.value,
                taxId: this.removeHyphens(formdata.get('employerIdNumber')?.value),
                firstName: formdata.get('firstName')?.value,
                lastName: formdata.get('lastName')?.value,
                emailAddress: formdata.get('email')?.value,
                type: AchEnrollmentAppConstants.ACH_ENROLLMENT_TYPE,
            };
        }
        return this.cleanObject(this.achEnrollment);
    }

    cleanObject(input: object): AchEnrollment {
        if (typeof input === 'object' && input !== null) {
            return Object.fromEntries(
                Object.entries(input)
                    .map(([key, val]) => [key, this.cleanObject(val)])
                    .filter(([, v]) => v !== null && v !== undefined && v !== '')
            );
        }
        return input;
    }

    removeHyphens(inputVal: string) {
        return inputVal?.replace(/-/g, '');
    }
}
